// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.uj-szak-page {
    padding: 40px;
    display: flex;
    justify-content: center;
    transition: margin-right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
}

.uj-szak-container {
    flex: 1 1;
    width: calc(100% - 80px);
    margin: 30px auto 20px auto; /* Kicseréltük a marginokat, hogy lejjebb csússzon a fejléc alól */
    background: #f9f9f9;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    max-width: none;
    transition: margin-right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);
}

.card {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 8px;
    margin-bottom: 20px;
    padding: 30px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: block;
    min-height: auto;
    min-height: 80px;
}

.card p {
    margin-top: 15px;
    text-align: left;
}

.card .data-row {
    display: flex;
    margin-bottom: 20px;
    align-items: flex-start;
    min-height: 24px;
    width: 100%;
}

.card .data-row .label {
    font-weight: bold;
    min-width: 220px;
    width: 220px;
    flex-shrink: 0;
    padding-right: 20px;
    color: #333;
    text-align: left;
}

.card .data-row .value {
    flex: 1 1;
    color: #555;
    line-height: 1.4;
    word-wrap: break-word;
}


.alapadatok-view h1 {
    color: #44ACC9;
    margin-bottom: 20px;
    margin-left: 0px;
    text-align: left;
    font-size: 2rem;
    font-weight: bold;
}

.alapadatok-view ul {
    list-style-type: none;
    padding: 0;
}

.alapadatok-view li {
    margin-bottom: 10px;
}

.alapadatok-view li div {
    margin-bottom: 5px;
    color: #333;
}

.alapadatok-view li strong {
    color: #000;
    font-weight: 600;
}

.alapadatok-view li div:last-child {
    margin-bottom: 0;
}

.szak-button-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}

.szak-button {
    background-color: #44ACC9;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
    transition: background-color 0.3s ease;
}

.szak-button:hover {
    background-color: #357a9d;
}

.card div {
    justify-content: space-between; 
}

.card div:last-child {
    margin-bottom: 0;
}

.card strong {
    min-width: 280px; /* Increased to match the longest label */
    text-align: left;
    font-weight: 600;
    color: #000;
    flex-shrink: 0;
}


.card span {
    flex: 1 1;
    text-align: left;
    color: #333;
}


.szakinfo-data div {
    justify-content: space-between; 
    display: flex;
    align-items: center;
    margin-bottom: 2px;
    padding: 8px 0; 
}


.szakinfo-data strong {
    min-width: 250px;
    min-width: 280px;
    text-align: left; 
    font-weight: 600;
    color: #000;
    flex-shrink: 0;
}

.szakinfo-data span {
    flex: 1 1;
    text-align: left; 
    color: #333;
    padding-left: 10px; 
}

.szakinfo-title {
    padding: 12px;
    text-align: left;
    border-bottom: 2px solid #ddd;
}

.szakinfo-content {
    padding: 12px;
    border-bottom: 1px solid #eee;
}

.remove-button {
    background-color: #dc3545;
    color: white;
    border: none;
    padding: 4px 8px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
}

.remove-button:hover {
    background-color: #c82333;  /* Darker shade of red */
}

.szakinfo-page {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.szakinfo-container {
    display: block;
    width: 100%;
    margin-bottom: 20px;
    flex: none;
}

.szakinfo-container-spaced {
    display: block;
    width: 100%;
    margin-top: 20px;
    clear: both;
    flex: none;
}

.section-header {
    margin-top: 0;
    margin-bottom: 20px;
}

.section-header-inline {
    margin-top: 0;
    margin-bottom: 0;
}

.section-header-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.add-reviewer-button {
    font-size: 14px;
    padding: 8px 16px;
}

.close-button {
    background-color: #44ACC9;
    color: white;
    border: none;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
}

.close-button:hover {
    background-color: #4D9EB8;
}



.confirm-remove-button {
    background-color: #dc3545;
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
}

.confirm-remove-button:hover {
    background-color: #c82333;  /* Darker shade of red */
}

.add-button {
    background-color: #28a745;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
}

.add-button:hover {
    background-color: #218838;  /* Darker shade of the original green */
}

.data-table {
    width: 100%;
    border-collapse: collapse;
}

.table-header-row {
    background-color: #f5f5f5;
}

.action-cell {
    padding: 12px;
    border-bottom: 1px solid #eee;
    text-align: center;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
}

.modal-content {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 500px;
    width: 90%;
    max-height: 80%;
    overflow: auto;
}

.modal-content-small {
    background-color: white;
    padding: 30px;
    border-radius: 8px;
    max-width: 400px;
    width: 90%;
    text-align: center;
}

.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.modal-header h2 {
    margin: 0;
    font-size: 1.5em;
}

.modal-search-container {
    margin-bottom: 15px;
}

.modal-search-input {
    width: 100%;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #ddd;
    font-size: 14px;
}

.dropdown-container {
    max-height: 300px;
    overflow-y: auto;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #f9f9f9;
}

.dropdown-item {
    padding: 12px;
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;
    transition: background-color 0.2s;
    border-bottom: 1px solid #eee;
}

.dropdown-item:last-child {
    border-bottom: none;
}

.dropdown-item:hover {
    background-color: #f8f9fa;
}

.dropdown-item-name {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 2px;
}

.dropdown-item-nk {
    font-weight: bold;
    font-size: 14px;
}

.dropdown-empty {
    padding: 20px;
    text-align: center;
    color: #666;
    background-color: white;
}

.modal-title-warning {
    margin-bottom: 20px;
    color: #dc3545;
}

.modal-text {
    margin-bottom: 25px;
    font-size: 16px;
}

.modal-button-container {
    display: flex;
    gap: 10px;
    justify-content: center;
}

/* Modal close button styles */
.modal-content .close-button,
.modal-content-small .close-button {
    background-color: #44ACC9 !important;
    color: white !important;
    border: none !important;
    padding: 8px 12px !important;
    border-radius: 4px !important;
    cursor: pointer !important;
    transition: background-color 0.3s ease !important;
    width: auto !important;
    height: auto !important;
    display: inline-block !important;
    min-width: 100px !important;
    font-size: 14px !important;
}

.modal-content .close-button:hover,
.modal-content-small .close-button:hover {
    background-color: #357a9d !important;
}

/* SideTile (oldalsó menü) eltolás kezelése az Alapadatok oldalon */
.uj-szak-container.side-tile-open {
    margin-right: 350px !important;
}
`, "",{"version":3,"sources":["webpack://./src/routes/AlapadatokView.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,8DAA8D;AAClE;;AAEA;IACI,SAAO;IACP,wBAAwB;IACxB,2BAA2B,EAAE,kEAAkE;IAC/F,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uCAAuC;IACvC,eAAe;IACf,8DAA8D;AAClE;;AAEA;IACI,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,wCAAwC;IACxC,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,mBAAmB;IACnB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,gBAAgB;IAChB,qBAAqB;AACzB;;;AAGA;IACI,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB,EAAE,yCAAyC;IAC3D,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;;AAGA;IACI,SAAO;IACP,gBAAgB;IAChB,WAAW;AACf;;;AAGA;IACI,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,cAAc;AAClB;;;AAGA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,SAAO;IACP,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB,GAAG,wBAAwB;AACxD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,WAAW;IACX,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,WAAW;IACX,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB,GAAG,wBAAwB;AACxD;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB,GAAG,uCAAuC;AACvE;;AAEA;IACI,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;AAC3B;;AAEA,8BAA8B;AAC9B;;IAEI,oCAAoC;IACpC,uBAAuB;IACvB,uBAAuB;IACvB,4BAA4B;IAC5B,6BAA6B;IAC7B,0BAA0B;IAC1B,iDAAiD;IACjD,sBAAsB;IACtB,uBAAuB;IACvB,gCAAgC;IAChC,2BAA2B;IAC3B,0BAA0B;AAC9B;;AAEA;;IAEI,oCAAoC;AACxC;;AAEA,mEAAmE;AACnE;IACI,8BAA8B;AAClC","sourcesContent":[".uj-szak-page {\n    padding: 40px;\n    display: flex;\n    justify-content: center;\n    transition: margin-right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);\n}\n\n.uj-szak-container {\n    flex: 1;\n    width: calc(100% - 80px);\n    margin: 30px auto 20px auto; /* Kicseréltük a marginokat, hogy lejjebb csússzon a fejléc alól */\n    background: #f9f9f9;\n    padding: 20px;\n    border-radius: 10px;\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n    max-width: none;\n    transition: margin-right 0.5s cubic-bezier(0.25, 0.1, 0.25, 1);\n}\n\n.card {\n    background-color: #fff;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    margin-bottom: 20px;\n    padding: 30px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    display: block;\n    min-height: auto;\n    min-height: 80px;\n}\n\n.card p {\n    margin-top: 15px;\n    text-align: left;\n}\n\n.card .data-row {\n    display: flex;\n    margin-bottom: 20px;\n    align-items: flex-start;\n    min-height: 24px;\n    width: 100%;\n}\n\n.card .data-row .label {\n    font-weight: bold;\n    min-width: 220px;\n    width: 220px;\n    flex-shrink: 0;\n    padding-right: 20px;\n    color: #333;\n    text-align: left;\n}\n\n.card .data-row .value {\n    flex: 1;\n    color: #555;\n    line-height: 1.4;\n    word-wrap: break-word;\n}\n\n\n.alapadatok-view h1 {\n    color: #44ACC9;\n    margin-bottom: 20px;\n    margin-left: 0px;\n    text-align: left;\n    font-size: 2rem;\n    font-weight: bold;\n}\n\n.alapadatok-view ul {\n    list-style-type: none;\n    padding: 0;\n}\n\n.alapadatok-view li {\n    margin-bottom: 10px;\n}\n\n.alapadatok-view li div {\n    margin-bottom: 5px;\n    color: #333;\n}\n\n.alapadatok-view li strong {\n    color: #000;\n    font-weight: 600;\n}\n\n.alapadatok-view li div:last-child {\n    margin-bottom: 0;\n}\n\n.szak-button-container {\n    display: flex;\n    justify-content: center;\n    margin-top: 20px;\n}\n\n.szak-button {\n    background-color: #44ACC9;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 16px;\n    transition: background-color 0.3s ease;\n}\n\n.szak-button:hover {\n    background-color: #357a9d;\n}\n\n.card div {\n    justify-content: space-between; \n}\n\n.card div:last-child {\n    margin-bottom: 0;\n}\n\n.card strong {\n    min-width: 280px; /* Increased to match the longest label */\n    text-align: left;\n    font-weight: 600;\n    color: #000;\n    flex-shrink: 0;\n}\n\n\n.card span {\n    flex: 1;\n    text-align: left;\n    color: #333;\n}\n\n\n.szakinfo-data div {\n    justify-content: space-between; \n    display: flex;\n    align-items: center;\n    margin-bottom: 2px;\n    padding: 8px 0; \n}\n\n\n.szakinfo-data strong {\n    min-width: 250px;\n    min-width: 280px;\n    text-align: left; \n    font-weight: 600;\n    color: #000;\n    flex-shrink: 0;\n}\n\n.szakinfo-data span {\n    flex: 1;\n    text-align: left; \n    color: #333;\n    padding-left: 10px; \n}\n\n.szakinfo-title {\n    padding: 12px;\n    text-align: left;\n    border-bottom: 2px solid #ddd;\n}\n\n.szakinfo-content {\n    padding: 12px;\n    border-bottom: 1px solid #eee;\n}\n\n.remove-button {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    padding: 4px 8px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.remove-button:hover {\n    background-color: #c82333;  /* Darker shade of red */\n}\n\n.szakinfo-page {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n}\n\n.szakinfo-container {\n    display: block;\n    width: 100%;\n    margin-bottom: 20px;\n    flex: none;\n}\n\n.szakinfo-container-spaced {\n    display: block;\n    width: 100%;\n    margin-top: 20px;\n    clear: both;\n    flex: none;\n}\n\n.section-header {\n    margin-top: 0;\n    margin-bottom: 20px;\n}\n\n.section-header-inline {\n    margin-top: 0;\n    margin-bottom: 0;\n}\n\n.section-header-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.add-reviewer-button {\n    font-size: 14px;\n    padding: 8px 16px;\n}\n\n.close-button {\n    background-color: #44ACC9;\n    color: white;\n    border: none;\n    padding: 8px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n}\n\n.close-button:hover {\n    background-color: #4D9EB8;\n}\n\n\n\n.confirm-remove-button {\n    background-color: #dc3545;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 14px;\n}\n\n.confirm-remove-button:hover {\n    background-color: #c82333;  /* Darker shade of red */\n}\n\n.add-button {\n    background-color: #28a745;\n    color: white;\n    border: none;\n    padding: 6px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.add-button:hover {\n    background-color: #218838;  /* Darker shade of the original green */\n}\n\n.data-table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.table-header-row {\n    background-color: #f5f5f5;\n}\n\n.action-cell {\n    padding: 12px;\n    border-bottom: 1px solid #eee;\n    text-align: center;\n}\n\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-color: rgba(0,0,0,0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n}\n\n.modal-content {\n    background-color: white;\n    padding: 20px;\n    border-radius: 8px;\n    max-width: 500px;\n    width: 90%;\n    max-height: 80%;\n    overflow: auto;\n}\n\n.modal-content-small {\n    background-color: white;\n    padding: 30px;\n    border-radius: 8px;\n    max-width: 400px;\n    width: 90%;\n    text-align: center;\n}\n\n.modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 20px;\n}\n\n.modal-header h2 {\n    margin: 0;\n    font-size: 1.5em;\n}\n\n.modal-search-container {\n    margin-bottom: 15px;\n}\n\n.modal-search-input {\n    width: 100%;\n    padding: 10px;\n    border-radius: 4px;\n    border: 1px solid #ddd;\n    font-size: 14px;\n}\n\n.dropdown-container {\n    max-height: 300px;\n    overflow-y: auto;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    background-color: #f9f9f9;\n}\n\n.dropdown-item {\n    padding: 12px;\n    cursor: pointer;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background-color: white;\n    transition: background-color 0.2s;\n    border-bottom: 1px solid #eee;\n}\n\n.dropdown-item:last-child {\n    border-bottom: none;\n}\n\n.dropdown-item:hover {\n    background-color: #f8f9fa;\n}\n\n.dropdown-item-name {\n    font-weight: bold;\n    font-size: 16px;\n    margin-bottom: 2px;\n}\n\n.dropdown-item-nk {\n    font-weight: bold;\n    font-size: 14px;\n}\n\n.dropdown-empty {\n    padding: 20px;\n    text-align: center;\n    color: #666;\n    background-color: white;\n}\n\n.modal-title-warning {\n    margin-bottom: 20px;\n    color: #dc3545;\n}\n\n.modal-text {\n    margin-bottom: 25px;\n    font-size: 16px;\n}\n\n.modal-button-container {\n    display: flex;\n    gap: 10px;\n    justify-content: center;\n}\n\n/* Modal close button styles */\n.modal-content .close-button,\n.modal-content-small .close-button {\n    background-color: #44ACC9 !important;\n    color: white !important;\n    border: none !important;\n    padding: 8px 12px !important;\n    border-radius: 4px !important;\n    cursor: pointer !important;\n    transition: background-color 0.3s ease !important;\n    width: auto !important;\n    height: auto !important;\n    display: inline-block !important;\n    min-width: 100px !important;\n    font-size: 14px !important;\n}\n\n.modal-content .close-button:hover,\n.modal-content-small .close-button:hover {\n    background-color: #357a9d !important;\n}\n\n/* SideTile (oldalsó menü) eltolás kezelése az Alapadatok oldalon */\n.uj-szak-container.side-tile-open {\n    margin-right: 350px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
